.cardImage {
    object-fit: cover;
    width: 100% !important;
    height: 200px !important;
}

.cardImagePreview {
    object-fit: cover;
    width: 100px !important;
    height: 100px !important;
}

.whiteBackground {
    width: 100vw;
    height: 100vh;
    background-color: white !important;
}

.card * {
    font-family: 'Outfit' !important;
}

/* Card Styling */
.card {
    border: 1px solid #e0e0e0 !important; /* Light grey border for the card */
    border-radius: 8px !important; /* Rounded corners */
    padding: 4px !important; /* Internal padding */
    margin: 8px !important;
    width: 90% !important;
    background-color: #ffffff !important; /* White background */
}

/* Card Header Styling */
.cardHeader {
    font-size: 18px !important; /* Slightly larger font for header */
    font-family: 'Outfit' !important;
    font-weight: bold !important; /* Bold text */
    color: #333333 !important; /* Dark grey for header text */
    margin-bottom: 8px !important; /* Space below the header */
}

/* Card Meta Styling */
.cardMeta {
    font-size: 14px !important; /* Smaller font for meta info */
    color: #888888 !important; /* Light grey for secondary text */
    margin-bottom: 4px !important; /* Space below meta info */
    font-family: 'Outfit' !important;
}

/* Card Description Styling */
.cardDescription {
    font-size: 16px !important; /* Medium font for description */
    color: #555555 !important; /* Slightly darker grey */
    margin-bottom: 4px !important; /* Space below the description */
}

.listItems {
    color: #b0b7d4;
    font-weight: 800;
    margin-top: 10px !important;
}

.link {
    color: #6c60fa;
}

.subtitle {
    color: #aea6b9 !important;
    letter-spacing: 3px;
    font-size: 13px;
    font-weight: 800;
    margin-top: 20px;
    margin-bottom: 5px;
}

.title {
    font-size: 40px;
    font-weight: 800;
    margin-top: 5px;
}

.bodyText {
    color: #aea6b9 !important;
    font-size: 16px;
}

.checkbox {
    background-color: #fff !important;
    padding: 10px;
    border-radius: 5px;
    z-index: 1000;
    position: absolute;
    margin: 10px;
    border: 1px solid #ddd;
}

/* Book Now Button Styling */
.bookNowButton {
    background-color: #ee5800 !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    gap: 8px !important;
    color: white !important;
    font-family: 'Outfit' !important;
    font-size: 16px !important;
    font-weight: 700 !important;
    padding: 10px 0px !important;
    border-radius: 8px !important;
    text-align: center; /* Center text */
    max-width: 250px !important;
    min-width: 150px !important;
    cursor: pointer; /* Pointer cursor on hover */
    transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease;
}

@media (max-width: 600px) {
    .bookNowButton {
        margin-top: 10px !important; /* Maintain spacing on mobile */
    }
}

/* Ensure parent container allows full width */
.horizontalContainer {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%; /* Ensure container takes full width */
}

.buttonContainer {
    display: flex;
    flex-direction: row; /* Default: Place buttons side by side */
    align-items: center; /* Vertically align */
    justify-content: space-between; /* Horizontally center */
    gap: 12px; /* Space between buttons */
    width: 100%;
    flex-wrap: wrap; /* Allows wrapping if needed */
}

/* Ensure buttons have consistent sizing */
.moreInfoButton,
.bookNowButton {
    width: auto; /* Prevents full width */
    min-width: 150px; /* Ensures consistency */
    text-align: center;
}

/* Responsive breakpoint for mobile */
@media (max-width: 600px) {
    .buttonContainer {
        flex-direction: column; /* Stack buttons on smaller screens */
        align-items: center; /* Center them */
    }

    .moreInfoButton,
    .bookNowButton {
        width: 100% !important; /* Make buttons full width on mobile */
    }
}
/* Responsive breakpoint for mobile */
@media (max-width: 600px) {
    .bookNowButton {
        width: 100% !important;
    }
    .moreInfoButton {
        width: 100% !important;
    }
}

.cardRating {
    color: grey !important;
}

.moreInfoButton {
    background-color: white !important;
    color: #707070 !important;
    border: #707070 1px solid !important;
    font-family: 'Outfit' !important;
    font-size: 16px !important;
    font-weight: 700 !important;
    padding: 10px 0px !important;
    border-radius: 8px !important;
    text-align: center; /* Center text */
    max-width: 220px !important;
    min-width: 150px !important;
    min-height: 40px !important;
    cursor: pointer; /* Pointer cursor on hover */
    transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease;
    margin: 1px !important;
}

/* Book Now Button Hover Effect */
.bookNowButton:hover {
    background-color: #f5f5f5; /* Light grey on hover */
    color: #000000; /* Black text on hover */
    border-color: #c0c0c0; /* Darker grey border on hover */
}

.priceMarker {
    border: 1px solid #d2d2d2;
    padding: 10px;
    border-radius: 20px;
    background-color: #fff !important;
    font-size: 20px;
    font-family: 'Outfit', sans-serif;
}

/* Flex container for price and button */
.priceAndButtonWrapper {
    display: flex;
    justify-content: space-between; /* Distribute price and button */
    align-items: center; /* Vertically center the elements */
    padding: 10px 0; /* Add spacing */
}

/* Price styling */
.price {
    font-size: 16px; /* Slightly larger font */
    font-weight: bold; /* Bold text */
    color: #666; /* Grey text for the price */
    font-family: 'Outfit' !important;
}

.priceMarker:hover {
    cursor: pointer;
}

.priceText {
    text-align: center;
    padding-top: 10px;
    color: #b0b7d4;
    font-size: 20px;
}

.sidebar {
    max-height: 90vh;
    overflow-y: auto;
}

/* width */
::-webkit-scrollbar {
    width: 5px !important;
}

/* Track */
::-webkit-scrollbar-track {
    margin-left: 10px;
    background: #fff !important;
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: #f0f0f8 !important;
    border-radius: 5px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: #dfdfe6 !important;
}

.rateContainer {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
}

.rateCard {
    cursor: pointer;
    font-family: 'Outfit';
    border: 2px solid #ccc !important;
    border-radius: 12px !important;
    padding: 0px !important;
    margin: 0px !important;
    transition: all 0.3s ease;
    flex: 1; /* Distributes available space */
}

.cardsGrid {
    display: grid;
    grid-template-columns: 48% 48%;
    justify-content: space-between;
}
.ratePane {
    border-color: transparent !important;
    padding-inline: 0 !important;
}
.rateCard:hover {
    border-color: #ff6600;
}

.selected {
    border-color: #ff6600 !important;
    box-shadow: 0px 0px 8px rgba(255, 102, 0, 0.3);
}

.rateHeader {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: bold;
    color: #333;
}

.rateTitle {
    font-size: 16px;
}
.rateRow {
    display: grid;
    grid-auto-flow: column;
    justify-content: space-between;
    padding-inline: 8px;
}
.monthlyHeader {
    padding: 0 8px 14px 8px;
}
.ratePrice {
    font-weight: bold;
    font-size: 16px;
}

.rateMax {
    font-size: 12px;
    color: #777;
    margin-top: 2px;
}
